// import Button from '../components/Button'
import React from 'react';
import styles from '../styles/evaluation.module.scss'
import btnStyles from '../styles/button.module.scss'
import AniLink from "gatsby-plugin-transition-link/AniLink";

function Evaluation(props) {
    return (
        <div className={styles.evaluation}>
            <div className={styles.evaluation_inner}>
                <h2>
                    <span className={styles.white}>em </span>
                    <span className={styles.equals}>=</span>
                    <span className={styles.orange}> ethos manifest </span>
                    <span className={styles.equals}>=</span>
                    <span className={styles.blue}> power</span>
                </h2>
                <p className={styles.small_paragraph}>Your Ethos Manifest is your guide to all things. It allows you to make decisions with clarity and ease, reduces stress, promotes self-empowerment, and leads to overall physical and mental well-being.</p>
                <p className={styles.small_headline}>Are you ready to start your ethos manifest journey?</p>
                <div className={styles.evaluation_btn}>
                    <AniLink 
                        cover 
                        to="/ethos/"  
                        direction="right" 
                        bg="#6AC9D0" 
                        role="button" 
                        className={btnStyles.button} 
                        style={{backgroundColor:'#FFBE76'}}>
                            START NOW
                    </AniLink>
                </div>
            </div>
        </div>
    )
}

export default Evaluation